import permissions from '../../data/permissions';

export default [
    {
        name: "PurchaseOrderDisplay",
        path: "order/:id",
        component: () => import('./../../views/purchase/PurchaseOrderDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.purchase_order.read }
    },
    {
        name: "PurchaseOrderEdit",
        path: "order/:id/edit",
        component: () => import('./../../views/purchase/PurchaseOrderEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.purchase_order.update }
    },
    {
        name: "PurchaseOrderCreate",
        path: "order",
        component: () => import('./../../views/purchase/PurchaseOrderCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.purchase_order.create }
    },
    {
        name: "PurchaseOrderList",
        path: "orders",
        component: () => import('./../../views/purchase/PurchaseOrderListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.purchase_order.index }
    },
    {
        name: "PurchaseOrderFulfillment",
        path: "orders-fulfillment",
        component: () => import('../../views/purchase/PurchaseOrderFulfillmentReportView.vue'),
        meta: { requiresAuth: true, authorization: permissions.report.purchase_order_fulfillment }
    },
    {
        name: "PurchaseOrderCompletion",
        path: "orders-completion",
        component: () => import('../../views/purchase/PurchaseOrderCompletionReportView.vue'),
        meta: { requiresAuth: true, authorization: permissions.report.purchase_order_fulfillment }
    },
    {
        name: "PurchaseSummaryReport",
        path: "purchase-summary",
        component: () => import('../../views/purchase/PurchaseSummaryReportView.vue'),
        meta: { requiresAuth: true, authorization: permissions.report.purchase_summary }
    }
];